import axios from "axios";
import ToastEventBus from "primevue/toasteventbus";

const baseDomain = process.env.VUE_APP_BACKEND_ADDRESS || "http://localhost";
const basePort = process.env.VUE_APP_BACKEND_PORT || "8001";
const baseURL = `${baseDomain}:${basePort}`; // Incase of /api/v1;

const toast = {
  add: (message) => ToastEventBus.emit("add", message),
  removeGroup: (group) => ToastEventBus.emit("remove-group", group),
  removeAllGroups: () => ToastEventBus.emit("remove-all-groups"),
};

const client = axios.create({
  baseURL,
  headers: {
    // "Authorization": "Bearer xxxxx"
  },
});

client.interceptors.response.use(
  function (response) {
    // Do something with response data
    return response;
  },
  function (error) {
    let title = error?.response?.data?.detail[0]?.type || error?.name;
    let msg = error?.response?.data?.detail[0]?.msg || error?.message;

    msg = msg ? msg.toString() : msg;

    if (title === "AxiosError") {
      // rename
      title = "Server Error";
    }

    if (msg === "Network Error") {
      //backend not running
      msg = "The backend server is unreachable";
    }
    toast.add({
      severity: "error",
      summary: title,
      detail: msg,
      life: 5000,
    });
    return error;
    // return Promise.reject(error);
  }
);

client.interceptors.request.use((config) => {
  const token = localStorage.getItem("bcx_auth_token");
  if (token) {
    config.headers["X-Access-Token"] = token;
  }
  return config;
});

export default client;
